import { ValueConstraintItem } from 'app/app-model/diagnostic-service/value.constraint.item.model';

export class ValueConstraint {
    id: number;
    validRange: any;
    items: ValueConstraintItem[];
}
